import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import ToolTip from "../../../parts/tooltip";
import SvgIcon from "../../../parts/SvgIcon";
import submit from "submit-form";
import ConfirmationModal from "../../../parts/modals/ConfirmationModal";
import { PRIMARIES_WITHOUT_SUFFIX } from "../../../constants";
import { getMuscleGroupLabel } from "../../../utils/muscle-group-label";
import { htmlToPlainText } from "../../../utils/html-to-plain-text";

const ExerciseLibraryLine = ({
  secondary,
  primaryItem,
  isAdminConsole,
  primary,
}) => {
  const { t } = useTranslation("coaching-portal");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleDelete = () => {
    setIsModalOpen(false);
    submit(getDeleteLink(secondary, isAdminConsole), {
      method: "GET",
    });
  };
  let primaryString =
    primary &&
    primary !== "assistant" &&
    !PRIMARIES_WITHOUT_SUFFIX.includes(primary)
      ? `(${primary.charAt(0).toUpperCase()}${primary.slice(1)})`
      : "";
  if (primaryString === "(OverheadPress)") primaryString = "(Overhead Press)";
  // instructions is HTML (catalog seed + coaching-portal editor); the tooltip
  // renders its content as text, so flatten it or the tags show through.
  const instructionsText = htmlToPlainText(secondary.instructions);
  return (
    <tr>
      <td>
        {!primaryItem && checkMissingMetadata(secondary) && (
          <ToolTip
            id={`exclamation_${secondary.movement}`}
            body={t("exerciseLibraryLine.someDataMissing")}
            hintClassNames="new-tooltip"
          >
            <div className="chip danger"></div>
          </ToolTip>
        )}
      </td>
      <td>
        {secondary.movement} {primaryString}
      </td>
      <td>
        {secondary.video &&
        (secondary.video.videoId || secondary.video.url !== "") ? (
          <a href={getVideoLink(secondary)}>
            <div className="chip video"></div>
          </a>
        ) : null}
      </td>
      <td>
        {instructionsText ? (
          <ToolTip
            id={`ins_${secondary.movement}`}
            body={instructionsText}
            hintClassNames="tooltip-instructions-style"
          >
            <SvgIcon
              src="/img/new-icons/grey-square-tick.svg"
              noFilterOnLight={false}
            />
          </ToolTip>
        ) : null}
      </td>
      <td>{getMuscleGroupLabel(secondary.primaryMuscleGroup, t)}</td>
      <td>{getMuscleGroupLabel(secondary.secondaryMuscleGroup, t)}</td>
      <td>{secondary.exerciseTypeField}</td>
      <td>
        <div>
          <a
            className="edit-table-action"
            role="button"
            data-button-type="primary"
            data-icon
            href={getLink(
              secondary.primary,
              primaryItem,
              secondary.index,
              secondary._id
            )}
            sz="medium"
          >
            <SvgIcon
              src="/img/new-icons/edit-pencil.svg"
              noFilterOnLight={true}
            />
            {t("exerciseLibraryLine.edit")}
          </a>
          {!primaryItem && (
            <>
              <button
                role="button"
                data-button-type="text-white"
                data-action="delete"
                data-icon
                // href={getDeleteLink(secondary, isAdminConsole)}
                onClick={() => setIsModalOpen(true)}
                sz="medium"
              >
                <SvgIcon
                  src="/img/new-icons/red-trash.svg"
                  noFilterOnLight={true}
                  alt="delete movement"
                />
              </button>
              <ConfirmationModal
                isOpen={isModalOpen}
                title={t("exerciseLibraryLine.deleteExercise")}
                contentText={t("exerciseLibraryLine.deleteExerciseConfirm")}
                cancelButtonText={t("exerciseLibraryLine.cancel")}
                cancelButtonAction={() => setIsModalOpen(false)}
                confirmButtonText={t("exerciseLibraryLine.delete")}
                confirmButtonAction={handleDelete}
                icon="delete"
              />
            </>
          )}
        </div>
      </td>
    </tr>
  );
};

function checkMissingMetadata(secondary) {
  return !secondary.video || !secondary.instructions;
}

function getLink(primary, primaryItem, i, id) {
  const type = primaryItem ? "primary" : primary;
  const urlEnd = id ? `&exercise=${id}` : `&modal[index]=${i}`;
  switch (type) {
    case "assistant":
      return `/actions/refresh?modal[type]=add-other-exercise&modal[primary]=${primary}${urlEnd}`;
    case "primary":
      return `/actions/refresh?modal[type]=edit-primary-movement&modal[primary]=${primary}`;
    default:
      return `/actions/refresh?modal[type]=add-secondary-movement&modal[primary]=${primary}${urlEnd}`;
  }
}

function getVideoLink(secondary) {
  const urlStart = `/actions/refresh?modal[type]=exercise-library-video&modal[primary]=${secondary.primary}`;
  const urlEnd = secondary._id
    ? `&exercise=${secondary._id}`
    : `&modal[index]=${secondary.index}`;
  return `${urlStart}${urlEnd}`;
}

function getDeleteLink(secondary, isAdminConsole) {
  const { _id, index, primary } = secondary;
  if (_id && isAdminConsole) {
    return `/actions/exercise-catalog/delete/${_id}`;
  }
  return `/actions/user/remove-secondary/${primary}/${index}`;
}

export default ExerciseLibraryLine;
